import Header from "../../header"
import jordanIntro from "url:../../../asset/jordan_intro.png"
import launchpadPhone from "url:../../../asset/bento/launchpad-phone.png"
import worshipSongsPreview from "url:../../../asset/bento/worship-songs.png"
import eventCards from "url:../../../asset/bento/event-cards.png"

import planningCenter from "url:../../../asset/bento/planning-center.png"
import smartwaiver from "url:../../../asset/bento/smartwaiver.png"

import launchpadTag from "url:../../../asset/bento/launchpadtag.png"
import LaunchpadSection from "./LaunchpadSection"
import LaunchpadTagsSection from "./LaunchpadTagsSection"

export default function Home() {
  return <div>
    <Header />

    {/* Full screen main */}
    <div className="w-full h-[60vh] flex items-center justify-center p-8 mb-32">
      <div className="text-center">
        <h1 className="text-6xl font-bold mb-6">👋 Meet <span className="text-accent">Salt</span></h1>
        <p className="text-5xl mb-8">
          <span className="text-accent font-bold">Delightful Tools</span> for your church.
        </p>
      </div>
    </div>

    <BentoSection />

    <LaunchpadSection />

    <LaunchpadTagsSection />

    <GetStartedCard />

    <MissionCard />
  </div>
}

function BentoSection() {
  return <div className="bg-[#F8F8F8] p-16">
    <div>
      <p className="font-semibold text-3xl">Delightful Tools for the Church.</p>
      <h1 className="font-semibold text-5xl text-accent">Here's just a few.</h1>

      <div id="bento-cards" className="flex flex-col md:flex-row gap-4 font-semibold text-2xl mt-16 md:max-h-100 overflow-hidden">
        <div className="bg-white rounded-4xl text-center flex flex-col flex-1/3 pt-12 min-h-10">
          <h1 className="mb-8">Launchpad</h1>

          <img src={launchpadPhone} className="mx-auto w-9/12 mt-auto" draggable={false} />
        </div>

        <div className="bg-white rounded-4xl text-center flex-1/2 overflow-clip pt-12">
          <h1 className="mb-8">Host Events</h1>

          <img src={eventCards} className="w-full mb-8" draggable={false} />
        </div>

        <div className="bg-white rounded-4xl text-center flex-1/3 pb-12">
          <img src={worshipSongsPreview} className="mx-auto w-2/3" draggable={false} />

          <h1 className="mt-12">Share Worship Songs</h1>
        </div>
      </div>

      <div id="bento-cards-row-2" className="flex flex-col md:flex-row gap-4 font-semibold text-2xl mt-4">
        <div className="bg-white rounded-4xl text-center flex flex-col flex-1/3 pt-12 pb-8">
          <h1 className="mb-8">Integrations</h1>

          <img src={planningCenter} className="mx-auto w-1/3 mb-4" draggable={false} />
          <img src={smartwaiver} className="mx-auto w-1/3 mb-4" draggable={false} />
        </div>

        <div className="bg-white rounded-4xl text-center flex-1/3 flex flex-row align-middle items-center justify-center px-12">
          <h1 className="mr-8">Launchpad Tags</h1>

          <img src={launchpadTag} className="h-48 my-4 drop-shadow-[0_4px_8px_rgba(0,0,0,0.2)] rounded-full" draggable={false} />
        </div>
      </div>
    </div>
  </div>
}

function GetStartedCard() {
  return <div className="p-16">
    <h1 className="text-accent font-semibold text-5xl">Get Started</h1>
    <p className="font-semibold text-3xl w-full md:w-2/3 mb-16 text-[#888888]">
      We'd love to partner with you as we work towards our vision of building Delightful Tools to that help churches connect with their members and communities.
      <br />
      <br />
      As we continue to build, we're partnering with a few churches in order to best support them in this early period.
      <br />
      <br />
      If you'd like to use Salt, please Connect with Us and our team will reach out!
    </p>

    <a href={"mailto:jordan@saltplatform.com"} target="_blank" rel="noopener noreferrer" className={`py-4 px-8 bg-accent text-white text-2xl rounded-full font-medium hover:cursor-pointer hover:opacity-75 transition-opacity duration-300`}>
      Connect with Us
    </a>
  </div>
}

function MissionCard() {
  return <div className="bg-linear-to-b from-accent to-[#E79D9D] text-white m-8 rounded-4xl p-16">
    <h1 className="font-semibold text-5xl mb-8">⛪️ We build Delightful Tools.</h1>
    <div className="font-medium text-2xl md:text-3xl w-full md:w-2/3">
      <p className="my-8">Salt's mission is simple- we build delightful tools to help supercharge your church.</p>
      <p className="my-8">Salt exists to save your church time, enhances programs, and helps members connect with each other and your resources.</p>
      <p className="my-8">We're here to help you every step of the way, all so you can spend more time leading and loving your members.</p>
    </div>

    <div className="mt-8">
      <img src={jordanIntro} alt="Jordan Intro" className="w-24" />

      <p className="text-lg font-medium mt-4">Jordan Osterberg</p>
      <p className="text-lg">Founder of Salt</p>
    </div>
  </div>
}